"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSelectButtonUtilityClass = getSelectButtonUtilityClass;
var _mui = require("@ori-ui/mui");
function getSelectButtonUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('SelectButton', slot);
}
const selectButtonClasses = (0, _mui.generateUtilityClasses)('SelectButton', ['root', 'content', 'focusVisible', 'disabled', 'selected']);
var _default = exports.default = selectButtonClasses;
